import { makeOnceFlag } from './onceFlag';

// One-shot "seen" flag for the effort-meter intro (AP-0b). The very first
// REAL tap on the meter auto-opens the EffortScaleModal so the athlete learns
// what the band means (scale anchors + RIR↔RPE switch) exactly once — across
// app restarts, not once per session (useBodyweightPrompt's in-memory ref is
// the wrong shape here). The storage mechanics moved into makeOnceFlag when the
// band-stop hint (TM-10) wanted the same three operations; what stays here is
// the key and what the flag MEANS.

const flag = makeOnceFlag('jackedlogs.effortMeterIntro.v1.seen');

export const getEffortIntroSeen = (): boolean => flag.get();
export const loadEffortIntroSeen = (): Promise<boolean> => flag.load();
export const markEffortIntroSeen = (): Promise<void> => flag.mark();
